import {StyleSheet, View} from 'react-native';
import {SafeAreaProvider} from 'react-native-safe-area-context';
import {DefaultTheme, Provider as PaperProvider} from 'react-native-paper';
import {AccessibilityProvider, useTheme} from './Hooks';
import MaterialCommunityIcons from './Web/MaterialCommunityIcons';

const renderIcon = ({
  name,
  color,
  size,
  direction,
}: {
  name: string;
  color?: string;
  size: number;
  direction: 'rtl' | 'ltr';
}) => <MaterialCommunityIcons name={name} color={color} size={size} direction={direction} />;

const AccessiblePaperProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const theme = useTheme();
  const paperTheme: typeof DefaultTheme = {
    ...DefaultTheme,
    colors: {
      ...DefaultTheme.colors,
      primary: theme.colors.primary,
      onPrimary: theme.colors.textContrast,
      outline: theme.colors.border,
      surface: theme.colors.surface,
      surfaceVariant: theme.colors.secondary,
      elevation: {
        ...DefaultTheme.colors.elevation,
        level2: theme.colors.secondary,
      },
    },
  };

  return (
    <PaperProvider theme={paperTheme} settings={{icon: renderIcon}}>
      {children}
    </PaperProvider>
  );
};

const Providers: React.FC<{children: React.ReactNode}> = ({children}) => {
  return (
    <View style={styles.root}>
      <SafeAreaProvider>
        <AccessibilityProvider>
          <AccessiblePaperProvider>{children}</AccessiblePaperProvider>
        </AccessibilityProvider>
      </SafeAreaProvider>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    minHeight: '100vh',
  },
});

export default Providers;
